import styled from '@emotion/styled';
import { Box, css, Flex } from 'theme-ui';
import pxToRem from '../../utils/pixelsToRem';

export const SectionNav = styled(Flex)(
  css({
    mt: '38px',
    justifyContent: 'center',
    gap: '6px',
    flexWrap: 'wrap',
    '@media print': {
      mt: '8px',
    },
  }),
);

export const SectionNavItem = styled(Box)(
  css({
    px: '44px',
    py: '10px',
    textTransform: 'capitalize',
    lineHeight: pxToRem(24),
    border: '1px solid',
    borderColor: 'searchBorder',
    cursor: 'pointer',
  }),
  ({ $isActive }) =>
    css({
      background: $isActive ? 'darkGreen' : 'white',
      color: $isActive ? 'white' : 'text',

      '&:hover': {
        background: !$isActive && 'grayMidDark',
      },
    }),
  ({ $isActive, $isModifiedSectionNavigationOnPrint }) =>
    css({
      '@media print': $isModifiedSectionNavigationOnPrint
        ? $isActive
          ? {
              display: 'block',
              color: 'text',
              border: 'none',
              background: 'none',
              fontStyle: 'italic',
            }
          : {
              display: 'none',
            }
        : {},
    }),
);
